<div id="quality-initiatives" class="watermark">
  <div class="container-fluid px-lg-5">
    <div class="row">
      <div class="col-12">
        <h2 class="title">Quality Initiatives by IQAC</h2>

        <h5 class="mt-3" style="color: var(--orange); font-weight: 600;">
          Transforming Education with Excellence and Equity
        </h5>

        <div class="mt-4 inner-lead">
          <p><strong>Induction of New Academic Programs:</strong></p>
          <ul>
            <li>Implementation of new academic programs in alignment with NEP–2020.</li>
          </ul>

          <p><strong>Infrastructure and Learning Resources:</strong></p>
          <ul>
            <li>Continuous creation and upgradation of infrastructure and learning resources.</li>
            <li>Automation of the library and office for efficient management.</li>
          </ul>

          <p><strong>Industry and Educational Collaborations:</strong></p>
          <ul>
            <li>Establishment of MOUs with industries and educational institutions to foster collaboration and growth.</li>
          </ul>

          <p><strong>Eco–Friendly Campus Development:</strong></p>
          <ul>
            <li>Implementation of initiatives to develop an eco–friendly campus.</li>
            <li>Activities include tree plantation, cleanliness campaigns, use of LED bulbs, and minimizing disposable items.</li>
          </ul>

          <p><strong>Job–Oriented and Skill Development Courses:</strong></p>
          <ul>
            <li>Introduction of job–oriented and skill development programs.</li>
            <li>Offering certificate courses through various centers of excellence.</li>
            <li>Launching value–oriented courses to enhance student competencies.</li>
          </ul>

          <p><strong>Extension Activities:</strong></p>
          <ul>
            <li>Active engagement in NSS activities to benefit the community.</li>
          </ul>

          <p><strong>Faculty Development Programs (FDPs):</strong></p>
          <ul>
            <li>Regular FDPs to enhance skills and knowledge of teaching staff.</li>
            <li>Skill development for non–teaching staff to improve workplace skills.</li>
          </ul>

          <p><strong>Social Inclusion and Scholarships:</strong></p>
          <ul>
            <li>Admission of more students from socially deprived communities with nominal fees.</li>
            <li>Provision of merit scholarships to deserving students.</li>
          </ul>

          <p><strong>Technological Advancements:</strong></p>
          <ul>
            <li>Installation of high–configuration ICT tools in labs and classrooms.</li>
            <li>Maintenance and upgradation of software and digital resources.</li>
          </ul>

          <p><strong>Continuous Improvement through MOUs:</strong></p>
          <ul>
            <li>Commitment to establishing MOUs with colleges and industries each academic session.</li>
          </ul>
        </div>

        <div class="text-center mt-5 mb-3 p-2" style="background-color: #f9b68d; font-weight: 600;">
          We endeavour to ‘Building Futures with Quality and Innovation’
        </div>

        <!-- TABLES SECTION -->
        <div class="ranked mb-4">
          <!-- Year 2021–22 -->
          <table class="table table-bordered table-hover align-middle ">
            <thead class="table-light">
              <tr>
                <th colspan="3" class="text-center">YEAR: 2021–22</th>
              </tr>
              <tr>
                <th>NAME OF THE ACTIVITY</th>
                <th>NATURE OF ACTIVITY</th>
                <th>DATE</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Professional Computer Skills</td>
                <td>PDP (Hartron Centre)</td>
                <td>16 May, 2022 to 21 May, 2022</td>
              </tr>
              <tr>
                <td>One Day Workshop on NAAC</td>
                <td>Workshop</td>
                <td>31 May, 2022</td>
              </tr>
            </tbody>
          </table>

          <!-- Year 2022–23 -->
          <table class="table table-bordered table-hover align-middle  mt-4">
            <thead class="table-light">
              <tr>
                <th colspan="3" class="text-center">YEAR: 2022–23</th>
              </tr>
              <tr>
                <th>NAME OF THE ACTIVITY</th>
                <th>NATURE OF ACTIVITY</th>
                <th>DATE</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>One Day Workshop on NAAC Awareness in SD College, Ambala</td>
                <td>Workshop</td>
                <td>17 Jun, 2022</td>
              </tr>
              <tr>
                <td>One Day Online Awareness Programme on Digital Bank Solution</td>
                <td>Workshop</td>
                <td>29 Sep, 2022</td>
              </tr>
              <tr>
                <td>PDP in Hartron Skill Centre</td>
                <td>One Week PDP</td>
                <td>12 Dec, 2022 to 17 Dec, 2022</td>
              </tr>
              <tr>
                <td>A Step–to–Step Guide to Write a Good Research Paper</td>
                <td>10 Days Workshop</td>
                <td>20 Dec, 2022 to 29 Dec, 2022</td>
              </tr>
              <tr>
                <td>Advance Leadership Skills and Creative Thinking</td>
                <td>3 Days FDP</td>
                <td>21 Dec, 2022 to 23 Dec, 2022</td>
              </tr>
              <tr>
                <td>FDP on Issues and Challenges of Revised Accreditation Framework of NAAC</td>
                <td>One Week Online FDP</td>
                <td>18 Jan, 2023 to 24 Jan, 2023</td>
              </tr>
              <tr>
                <td>Talk on NAAC–Revised Framework</td>
                <td>Extension Talk</td>
                <td>13 May, 2023</td>
              </tr>
              <tr>
                <td>Workshop on Positivity and Interpretation in Communication</td>
                <td>One Day Workshop</td>
                <td>20 May, 2023</td>
              </tr>
            </tbody>
          </table>

          <!-- Year 2023–24 -->
          <table class="table table-bordered table-hover align-middle mt-4">
            <thead class="table-light">
              <tr>
                <th colspan="3" class="text-center">YEAR: 2023–24</th>
              </tr>
              <tr>
                <th>NAME OF THE ACTIVITY</th>
                <th>NATURE OF ACTIVITY</th>
                <th>DATE</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Expert Lecture on Revised Assessment and Accreditation Framework of NAAC – An Approach</td>
                <td>Seminar</td>
                <td>27 Mar, 2023</td>
              </tr>
              <tr>
                <td>Elevating Office Workshop Potential</td>
                <td>One Week Online PDP</td>
                <td>29 April, 2024 to 03 May, 2024</td>
              </tr>
              <tr>
                <td>Effective Usage of ICT Tools for Teaching–Learning</td>
                <td>One Day Workshop</td>
                <td>05 Jan, 2024</td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>
  </div>
</div>
